import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { IntakeLabel } from '../../entities/intake-label.interface';
import { MINISTRY_NAME_LONG, MINISTRY_NAME_SHORT } from '../../constants/ministry-name';
export interface DeclarationLabelsLookup extends IntakeLabel {
  label: string;
  householdSituation?: boolean;
  requiresSchedule?: boolean;
  orderedListItem?: number;
  excludeFromPdf?: boolean;
  placeHolder?: boolean;
}

export const IesDeclarationLabels: { [name: string]: DeclarationLabelsLookup } = {
  declarationItem1: {
    label: `The information on this application describes the financial and household situation for:
     <ul>
      <li>me <b>or</b> the person for whom I am the Financial Administrator.</li>
      <li>my spouse/partner.</li>
      <li>my dependents.</li>
    </ul>
    `,
    householdSituation: true,
    orderedListItem: 1,
  },
  declarationItem2: {
    label: `When I am receiving Income Support benefits, I will report <b>as soon as possible</b> to my worker:
    <ul>
      <li>all money that I or anyone in my household receive from any source.</li>
      <li>any change in my household situation.</li>
      <li>any change in things my spouse/partner or I own.</li>
    </ul>`,
    orderedListItem: 2,
  },
  declarationItem3: {
    label: `I understand that:
    <ul>
      <li>Alberta ${MINISTRY_NAME_LONG} (${MINISTRY_NAME_SHORT}) has the right to apply for child/adult support for me and/or my dependent children and that the Government of Alberta may retain any of the support owing to the government.</li>
      <li>I must notify and/or receive consent from Child Support Services, ${MINISTRY_NAME_SHORT} when taking my own support action.</li>
      <li>when required I must help the Government of Alberta to pursue support for me and my dependent children. </li>
    </ul>`,
    orderedListItem: 3,
  },
  declarationItem4: {
    label: `I understand ${MINISTRY_NAME_SHORT} has the right to recover benefits I receive to which I am not entitled. This includes those issued due to administrative error.`,
    orderedListItem: 4,
  },
  declarationItem5: {
    label: 'I understand I have the right to appeal a decision within 30 days of being told of the decision.',
    orderedListItem: 5,
  },
  declarationItem6: {
    label: `I understand that ${MINISTRY_NAME_SHORT} and/or ${MINISTRY_NAME_SHORT} contracted services may get information about my financial, work, educational, medical and/or household situation to:
    <ul>
      <li>determine my eligibility for Income Support, or</li>
      <li>conduct a review or investigation relating to eligibility or continuing eligibility for these program benefits.</li>
    </ul>
    I ask any person, agency, institution or other source to give the required information to ${MINISTRY_NAME_SHORT} and/or ${MINISTRY_NAME_SHORT} contracted services. `,
    orderedListItem: 6,
  },
  declarationItem7: {
    label: `I understand that relevant personal information may be shared with other Government of Alberta programs and services, including contracted services, and with community partners.`,
    orderedListItem: 7,
  },
  declarationItem8: {
    label: `I understand ${MINISTRY_NAME_SHORT} may conduct reviews or investigations relating to financial eligibility for this program. I acknowledge that I must provide information or documents as required by ${MINISTRY_NAME_SHORT} to verify any statement made on this application or information given to my worker.`,
    orderedListItem: 8,
  },
  declarationItem9: {
    label: `I understand that I must comply with program expectations to continue to be eligible for benefits.`,
    orderedListItem: 9,
  },
  declarationItem10: {
    label: `If I am a Financial Administrator or other legal representative, I understand what this Declaration means as it applies to the applicant.`,
    orderedListItem: 10,
  },
  declarationItem11: {
    label: `I understand that I must complete the Canada Revenue Agency consent to be eligible for benefits.`,
    orderedListItem: 11,
  },
  declarationItem12: {
    label: `I understand that giving false or incomplete information or not advising of changes in my situation may result in any or all of the following: termination or suspension of benefits, repayment of benefits received, and/or laying of a charge under the <em>Income and Employment Supports Act</em> <span>or the</span> <em>Criminal Code of Canada.</em>`,
    orderedListItem: 12,
  },
  agreeDeclarationContent: {
    label: `<b>
        I understand that regardless of who in my family is the designated reporter for the Automated Reporting for Clients system, it is my responsibility to ensure any changes in my situation have been reported to the department.
    </b>`,
  },
  agreeDeclaration: {
    label: 'I have read, understood and agree with the above statements.',
    excludeFromPdf: true,
  },
  truthDeclaration: {
    label: 'I declare that the information in this application is true and complete.',
    excludeFromPdf: true,
  },
};

export const IesDeclarationCheckboxLabels: IntakeLabelCollection = {
  householdMe: {
    label: 'Me',
  },
  householdSpouseOrPartner: {
    label: 'My spouse/partner',
  },
  householdDependent: {
    label: 'My dependents',
  },
  requiresScheduleA: {
    label: 'Schedule A - Child Support Services',
  },
  requiresScheduleC: {
    label: 'Confirm that Schedule C - Declaration of 18 or 19 year old dependent(s) is included with this application.',
  },
};

export const IesPrivacyLabels: IntakeLabelCollection = {
  privacyContent: {
    label: `The personal information you provide is being collected to determine your eligibility for different social-based supports and benefits offered by the Government of Alberta under Alberta Supports.
    <br /><br /> 
    If you choose to apply, the personal information you provide will be entered into an automated system to validate self-reported information. 
    <br /><br />
    The personal information provided to Alberta Supports is collected under the authority of sections 4(a) and 4(c) of the <em>Protection of Privacy Act</em> and section 14 of the <em>Income and Employment Supports Act</em>. 
    <br /><br />
    If you have questions about the collection of personal information, please contact the Alberta Supports Contact Centre toll-free at 1-877-644-9992, from 7:30 a.m. to 8:00 p.m. every Monday to Friday, except statutory holidays.`,
  },
};
